import React from 'react';
import './references.scss';
import {referenceDemos, referenceIntroEng, referenceIntroHun, referenceLogos, referenceTitle} from "../demo_page/content";

class References extends React.Component {
    componentDidMount() {
        setTimeout(function () {
            document.querySelector(".loader-wrapper").style = "display: none";
        }, 2000);
    }
    render() {
        const isEng = this.props.language && this.props.language === 'ENG';

        const demoList = referenceDemos.map((val, i) => {
            return (
                <div className="col-xl-4 col-lg-6 col-12 text-center" key={i}>
                    <div key={i}>
                        {/*<a href={val.link} target="_blank" key={i}>*/}
							<span className="pc-bg" key={i}>
								<span style={{ backgroundImage: val.imgUrl }} key={i} className="img-scroll"/>
							</span>
                        {/*</a>*/}
                    </div>
                    <h2 className="demo-title">{isEng ? val.labelEng : val.labelHun} </h2>
                    <p style={{display: 'none'}}>{isEng ? val.descEng : val.descHun}</p>
                </div>
            );
        });
        
        const partnerLogoImages = referenceLogos.map((val, i) => {
            return (
                <img className={'partner-logo'} src={val.source} title={val.alt} alt={val.alt} key={i}/>
            );
        });

        return (
            <section className="fadinup solutions-personalized" id="references">
                <div className="container-fluid m-width">
                    <div className="row">
                        <div className="col-md-12">
                            <h2 className="title center-text">{isEng ? referenceTitle.eng : referenceTitle.hun}</h2>
                            <div className="border-shape"></div>
                        </div>
                        <div className="">
                            <p className="caption-about">{isEng ? referenceIntroEng : referenceIntroHun}</p>
                        </div>
                    </div>
                    <div className={'logo-container'}>
                       {partnerLogoImages}
                    </div>
                    <div className="laptops row mt-35 landing-screen-animation">
                        {demoList}
                    </div>
                </div>
            </section>
        );
    }
}

export default References;


// WEBPACK FOOTER //
// ./src/components/references.js